export default "<div class=\"error-box\">{{message}}</div>\n"